import { defineComponent as _defineComponent } from 'vue'
import { EmailOptions, Trade } from 'ah-api-gateways';
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { emailField } from 'ah-common-lib/src/form/models';
import { BModal } from 'bootstrap-vue';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { ref, reactive } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhTradesState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResendTradeConfEmailModal',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: Trade;
};

const modal = ref<BModal | null>(null);
const tradeState = useAhTradesState();



const requestManager = useRequestManager({
  exposeToParent: ['sendTradeEmailConfirmation'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'sendTradeEmailConfirmation') {
      send();
    }
  },
});

const emailForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'emailForm',
    fieldType: 'form',
    fields: [
      emailField('recipient', 'Recipient', { required: true }),
      emailField('cc', 'cc', { required: false }),
      emailField('bcc', 'bcc', { required: false }),
    ],
  }),
  validation: null,
});

function show() {
  modal.value?.show();
}

function hide() {
  modal.value?.hide();
}

function send() {
  /**
   * Send email after all validations have been checked
   */
  if (emailForm.validation) {
    submitForm(emailForm.validation);
    if (emailForm.validation.$invalid) {
      return;
    }
    let emailOptions = {
      cc: [emailForm.form.cc],
      bcc: [emailForm.form.bcc],
      to: [emailForm.form.recipient],
    } as Partial<EmailOptions>;

    requestManager.manager
      .cancelAndNew(
        'sendTradeEmailConfirmation',
        tradeState.services.notification.resendTradeConfirmation(props.trade.id, emailOptions)
      )
      .subscribe(() => {
        tradeState.toast.success('Trade confirmation resend successfully');
        hide();
      });
  }
}

return { __sfc: true,modal, tradeState, props, requestManager, emailForm, show, hide, send, BModal }
}

})